export default __webpack_public_path__ + "static/media/avatar9.2db98189.png";